// a version based approach to upgrading a database
import * as uuid from "uuid";

export const pageNames = {
    commercialSearch: "commercial-simulation-search",
    residentialSearch: "residential-simulation-search",
    skylights: "skylights",
    films: "films"
};
export function hash(name: string) {
    return `#${name}`;
}

export const newGuid: () => string = self.crypto && (self.crypto as any).randomUUID
    ? (): string => {
        return (self.crypto as any).randomUUID();
    }
    : (): string => {
        return uuid.v4();
    };